import { TAccount } from '@/models/account-model'
import { User } from '@/pages/users/types'

export const accountToUser = (account: TAccount): User => {
  return {
    id: account.id,
    fullname: `${account.person.firstName} ${account.person.lastName}`,
    username: account.username ?? account.login,
    email: account.login,
    role: account.roles[0],
    projects: [],
    avatar: '',
    notes: '',
    active: account.enablement.enabled,
    created_at: account.createdAt,
    tenantKey: account.tenantKey,
  }
}

export const userToAccount = (user: User): TAccount => {
  return {
    id: user.id,
    person: {
      firstName: user.fullname.split(' ')[0],
      lastName: user.fullname.split(' ')[1],
    },
    login: user.email,
    username: user.username,
    roles: [user.role],
    enablement: {
      enabled: user.active,
    },
    useMFA: false,
    tenantKey: user.tenantKey,
  }
}
